/* eslint-disable jsx-a11y/alt-text */
import {Fragment, useState, useEffect} from 'react'
import {Button, Col, Modal, Row} from 'react-bootstrap'
import '../Overview.css'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {useNavigate, useParams} from 'react-router-dom'
import JobServices from '../../../../../services/job'
import ApplyForm from './ApplyForm'
import HTMLRenderer from 'react-html-renderer'
import numberFormat from '../../../../../utils/helpers/NumberFormat'
import {toAbsoluteUrl} from '_metronic/helpers'
import {dateFormat} from 'thesis-and-dissertations/helpers/helper'

const JobDetail = () => {
  const navigate = useNavigate()
  const [show, setShow] = useState<any>(false)
  const [job, setJob] = useState<any>(null)
  let params = useParams()
  useEffect(() => {
    detailJob()
  }, [])

  const detailJob = async () => {
    try {
      const resp: any = await JobServices.showJob(params?.jobId)
      setJob(resp.data)
    } catch (error) {
    }
  }
  const toggle = () => setShow(!show)
  return (
    <Fragment>
      {/* localStorage.getItem('role') == 'Alumni' */}
      {false ? (
        <PageTitle
          breadcrumbs={[
            {
              title: 'Dashboard',
              path: '/dashboard',
              isSeparator: false,
              isActive: false,
            },
            {
              title: '/',
              path: '',
              isSeparator: false,
              isActive: false,
            },
            {
              title: 'Cari Lowongan Pekerjaan',
              path: '/job-search',
              isSeparator: false,
              isActive: false,
            },
            {
              title: '/',
              path: '',
              isSeparator: false,
              isActive: false,
            },
          ]}
        >
          {job?.company_jobs_title}
        </PageTitle>
      ) : (
        <Button onClick={() => navigate(-1)} className='btn-sm mb-8' style={{padding: '4px'}}>
          <i className='bi bi-arrow-left fs-1'></i>
        </Button>
      )}
      <Modal show={show} onHide={toggle} size='lg'>
        <Modal.Header closeButton>
          <Modal.Title> Pengajuan Lamaran</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ApplyForm toggle={toggle} job={job} />
        </Modal.Body>
      </Modal>
      <Row>
        <Col md={12} className={'mb-8'}>
          <div className='card-custom'>
            <Row>
              <Col md={3}>
                <img
                  src={job?.company?.logo_url_full || toAbsoluteUrl('/media/avatars/300-1.jpg')}
                  alt='Metornic'
                  style={{display: 'block', height: '130px', width: '130px'}}
                />

                {/* <div
                  style={{
                    background: '#D9D9D9',
                    borderRadius: '10px',
                    height: '200px',
                    width: '200px',
                  }}
                /> */}
              </Col>
              <Col style={{paddingTop: '3%'}}>
                <h5>{job?.company_jobs_title || '-'}</h5>
                <p>{job?.company?.companies_name || '-'}</p>
                <span style={{color: 'rgba(0, 0, 0, 0.53)'}}>
                  {job?.company?.city?.cities_name.toUpperCase()},{' '}
                  {job?.company?.city?.province?.country?.countries_name.toUpperCase()}
                </span>
                <br />
                <br />
                {localStorage.getItem('role') == 'Alumni' && (
                  <Fragment>
                    {job?.already_applied ? (
                      <Button className='btn-sm btn-secondary'>Sudah Mendaftar</Button>
                    ) : (
                      <Button onClick={toggle} className='btn-sm'>
                        Ajukan Lamaran
                      </Button>
                    )}
                    {'  '}
                  </Fragment>
                )}
                <Button
                  variant='secondary'
                  className='btn-sm ml-6'
                  style={{marginLeft: '10px'}}
                  onClick={() =>
                    navigate(
                      `/crafted/pages/profile/company-overview?company=${job?.company?.id_hash}`
                    )
                  }
                >
                  Lihat Perusahaan
                </Button>
              </Col>
            </Row>
          </div>
        </Col>
        <Col md={12} className={'mb-8'}>
          <div className='card-custom'>
            <h6 className='mb-4'>DETAIL PEKERJAAN</h6>
            <Row>
              <Col md={4} className='mb-8'>
                <span>Jenis Pekerjaan</span>
                <br />
                <span style={{fontWeight: 'bold'}}>{job?.working_type?.working_types_name}</span>
              </Col>
              <Col md={4} className='mb-8'>
                <span>Pengalaman Kerja</span>
                <br />
                <span style={{fontWeight: 'bold'}}>
                  {job?.company_jobs_years_of_experience} Tahun
                </span>
              </Col>
              <Col md={4} className='mb-8'>
                <span>Dapat dikerjakan Remote?</span>
                <br />
                <span style={{fontWeight: 'bold'}}>Tidak</span>
              </Col>
              <Col md={4} className='mb-8'>
                <span>Jenjang Pendidikan Minimum</span>
                <br />
                <span style={{fontWeight: 'bold'}}>{job?.degree?.degrees_name}</span>
              </Col>
              <Col md={4} className='mb-8'>
                <span>Job Level</span>
                <br />
                <span style={{fontWeight: 'bold'}}>{job?.job_level?.job_levels_name}</span>
              </Col>
              <Col md={4} className='mb-8'>
                <span>Gaji</span>
                <br />
                <span style={{fontWeight: 'bold'}}>{numberFormat(job?.salary)}</span>
              </Col>
              {/* <Col md={4} className='mb-8'>
                <span>Jam Kerja</span>
                <br />
                <span style={{fontWeight: 'bold'}}>
                  {job?.company_jobs_working_time_start} - {job?.company_jobs_working_time_end} WIB
                </span>
              </Col> */}
              <Col md={4} className='mb-8'>
                <span>Periode Lowongan</span>
                <br />
                <span style={{fontWeight: 'bold'}}>
                  {dateFormat(job?.created_at)} - {dateFormat(job?.company_jobs_expired_date)}
                </span>
              </Col>
              <Col md={4} className='mb-8'>
                <span>Status Lowongan</span>
                <br />
                <span style={{fontWeight: 'bold'}}>Aktif</span>
              </Col>
              <Col md={12}>
                <span>Keahlian</span>
                <div className='mt-6 mb-10' style={{maxWidth: '100%'}}>
                  {job?.job_skills.length > 0
                    ? job?.job_skills.map((item: any, key: any) => {
                        return (
                          <span
                            key={key}
                            style={{
                              borderRadius: '10px',
                            }}
                            className='badge badge-primary p-4 m-1'
                          >
                            {item?.skill?.skills_name}
                          </span>
                        )
                      })
                    : '-'}
                </div>
              </Col>
              <Col md={12}>
                <span>Bahasa</span>
                <br />
                <br />
                {job?.job_languages.length > 0
                  ? job?.job_languages.map((item: any, key: any) => {
                      return (
                        <span
                          key={key}
                          style={{
                            borderRadius: '10px',
                          }}
                          className='badge badge-primary p-4 m-1'
                        >
                          {item?.language?.languages_name}
                        </span>
                      )
                    })
                  : '-'}
                <br />
                <br />
              </Col>
            </Row>
          </div>
        </Col>
        <Col md={12} className={'mb-8'}>
          <div className='card-custom'>
            <h6 className='mb-8'>DESKRIPSI PEKERJAAN</h6>
            <HTMLRenderer html={job?.company_jobs_description ?? '-'} />
          </div>
        </Col>
        <Col md={12} className={'mb-8'}>
          <div className='card-custom'>
            <h6 className='mb-8'>Kualifikasi</h6>
            <HTMLRenderer html={job?.company_jobs_qualification} />
          </div>
        </Col>
        <Col md={12} className={'mb-8'}>
          <div className='card-custom'>
            <h6 className='mb-8'>Benefit</h6>
            <HTMLRenderer html={job?.company_jobs_benefit} />
          </div>
        </Col>
      </Row>
      {localStorage.getItem('role') == 'Alumni' && (
        <Fragment>
          {job?.already_applied ? (
            <Button className='btn btn-sm btn-secondary' style={{marginLeft: '40%'}}>
              Sudah Mendaftar
            </Button>
          ) : (
            <Button className='btn btn-sm' style={{marginLeft: '40%'}} onClick={toggle}>
              Ajukan Lamaran
            </Button>
          )}
        </Fragment>
      )}
    </Fragment>
  )
}

export default JobDetail
